/*
 * @Author: your name
 * @Date: 2020-03-13 16:27:57
 * @LastEditTime: 2020-03-14 21:53:01
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \kkcloud-kk-bote\src\utils\requestHeader.ts
 */
import KKApiSign from '@ty-front/kk-api-sign';
import { getAppKey, getSecret } from '@/utils/service-common';
import { uuid } from '@/utils/uuid';
console.log(KKApiSign, 'xxxxxxxxxx');
export var apiSign = new KKApiSign(getAppKey({}).data, getSecret({}).data);
console.log(apiSign.getHeaderParams({
    platformType: 6,
    equipment: 'web-windows-hhkl2n12mzg-lt5x8mqjami',
}), 'yyyy');
export var headers = {
    'TB-CLIENT-TYPE': 'web',
    'TB-VERSION': 'v1.0.1',
    'TB-TOKEN': '',
    'TB-UUID': localStorage.getItem('_uuid') ||
        (function () {
            // 当本地localStorage中不存在UUID值时
            // 生成UUID
            var UUID = uuid();
            try {
                // 同时将数据进行本地存储
                localStorage.setItem('_uuid', UUID);
                // tslint:disable-next-line:no-empty
            }
            catch (e) { }
            // 将数据返回
            return UUID;
        })(),
    'Content-Type': 'application/json',
    // 'TB-SITE-ID': process.env.SITE_ID || '1',
    'TB-SITE-ID': '1',
};
